// dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import componentBase from '../../../../../../../../src/lib/component-base';
// children
import ExportMultiSelects from './children/ExportMultiSelects';
import DateSelector from './children/DateSelector';
// static assets
import departureIcon from '../../../../../../../../static/images/data-export-icons/Departures-Icons-WHITE.svg';
import arrivalIcon from '../../../../../../../../static/images/data-export-icons/Arrivals-Icons-WHITE.svg';
import depArrIcon from '../../../../../../../../static/images/data-export-icons/DepArr-Icon-White.svg';

@componentBase('DateAndMultiSelect')
export default class DateAndMultiSelect extends Component {
  static propTypes = {
    arrivalAirports: PropTypes.array,
    arrivalCountries: PropTypes.array,
    arrivalCheckedSearch: PropTypes.string,
    arrivalCheckedSearchInvalid: PropTypes.string,
    arrivalRegions: PropTypes.array,
    departureAirports: PropTypes.array,
    departureCountries: PropTypes.array,
    departureCheckedSearch: PropTypes.string,
    departureCheckedSearchInvalid: PropTypes.string,
    departureRegions: PropTypes.array,
    dispatch: PropTypes.func,
    inputObjectDefaults: PropTypes.object,
    params: PropTypes.object,
    selectedEndDate: PropTypes.object,
    selectedStartDateInvalid: PropTypes.string,
    selectedEndDateInvalid: PropTypes.string,
    selectedStartDate: PropTypes.object,
    serverDate: PropTypes.object,
    user: PropTypes.object,
  };

  showDepartureFilters = () => {
    const {
      params,
    } = this.props;
    if (params) {
      const {
        exportType,
      } = params;
      if (exportType) {
        return exportType === 'route' || exportType === 'departing';
      }
    }
    return false;
  }

  showArrivalFilters = () => {
    const {
      params,
    } = this.props;
    if (params) {
      const {
        exportType,
      } = params;
      if (exportType) {
        return exportType !== 'departing';
      }
    }
    return false;
  }

  showDepArrIcon = () => {
    const {
      params,
    } = this.props;
    if (params) {
      const {
        exportType,
      } = params;
      if (exportType) {
        return exportType === 'deparr';
      }
    }
    return false;
  }

  render() {
    const {
      arrivalAirports,
      arrivalCountries,
      arrivalCheckedSearch,
      arrivalCheckedSearchInvalid,
      departureCheckedSearch,
      departureCheckedSearchInvalid,
      arrivalRegions,
      departureAirports,
      departureCountries,
      departureRegions,
      dispatch,
      inputObjectDefaults,
      params,
      selectedEndDate,
      selectedStartDate,
      selectedEndDateInvalid,
      selectedStartDateInvalid,
      serverDate,
      user,
    } = this.props;
    return (
      <div className='data-export-info-container-multi row'>
        <div className='col-xs-12'>
          <DateSelector
            dispatch={dispatch}
            inputObjectDefaults={inputObjectDefaults}
            selectedEndDate={selectedEndDate}
            selectedEndDateInvalid={selectedEndDateInvalid}
            selectedStartDate={selectedStartDate}
            selectedStartDateInvalid={selectedStartDateInvalid}
            serverDate={serverDate}
            user={user}
          />
        </div>
        <div className='col-xs-12'>
          <div className='row multi-selects'>
            {this.showDepartureFilters() && <div className='col-xs-12 col-sm-5 departures'>
              <ExportMultiSelects
                departureCheckedSearch={departureCheckedSearch}
                checkedSearchInvalid={departureCheckedSearchInvalid}
                departureAirports={departureAirports}
                departureCountries={departureCountries}
                departureRegions={departureRegions}
                dispatch={dispatch}
                name='departure'
                params={params}
                icon={departureIcon}
                title='Departure Filters'
              />
            </div>}
            {this.showArrivalFilters() && <div className={`col-xs-12 col-sm-5 arrivals ${this.showDepartureFilters() ? 'with-departures col-sm-offset-1' : ''}`}>
              <ExportMultiSelects
                arrivalCheckedSearch={arrivalCheckedSearch}
                checkedSearchInvalid={arrivalCheckedSearchInvalid}
                arrivalAirports={arrivalAirports}
                arrivalCountries={arrivalCountries}
                arrivalRegions={arrivalRegions}
                dispatch={dispatch}
                name='arrival'
                params={params}
                icon={this.showDepArrIcon() ? depArrIcon : arrivalIcon}
                title={`${this.showDepArrIcon() ? 'Departure or Arrival' : 'Arrival'} Filters`}
              />
            </div>}
          </div>
        </div>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./modules/DataExports/components/ExportsSearch/children/CompileDataForm/children/DateAndMultiSelect/DateAndMultiSelect.js